// extracted by mini-css-extract-plugin
export default {"page-position":"Pagenation_page-position__LGHcd","oval":"Pagenation_oval__-dKc0","hidden":"Pagenation_hidden__gT4sf","hide":"Pagenation_hide__U1MB1"};